var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('main-toolbar'),_vm._v(" "),_c('v-layout',{staticClass:"hidden-sm-and-down",attrs:{"row":"","justify-center":""}},[_c('v-card',{staticClass:"surfAndScanborder",staticStyle:{"min-width":"50%"}},[_c('v-layout',{staticClass:"row justify-content-center"},[_vm._v("\n        Der Einkauf war erfolgreich.\n      ")])],1)],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-471f948e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ShopSuccess.vue
// module id = null
// module chunks = 